import styled from 'styled-components';
import { QUALITY_MARK_ASPECT_RATIO, breakpoints } from 'config/config';

export const StyledThirdHeader = styled('div')`
  &.bread-wrapper {
    border-bottom: 1px solid ${(props) => props.theme.borderBottom};
  }

  .breadcrumbs-icon {
    font-size: 14px;
    padding: 0 5px;
  }

  .ant-select-selector,
  .ant-select,
  .ant-form-item-control-input {
    height: 24px !important;
    min-height: 24px !important;

    .ant-select-selection-item {
      line-height: 14px !important;
      padding-top: 0 !important;
    }
  }

  .ant-form-item {
    margin-bottom: 0;
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    display: none;
  }

  .product-name-bread-wrapper {
    flex-grow: 1;
    border-bottom: 1px solid ${(props) => props.theme.borderBottom};
    padding-bottom: 13px;

    .breadcrumbs-container {
      display: flex;
      justify-content: space-between;

      .breadcrumb {
        cursor: pointer;
      }

      div {
        display: flex;
        align-items: center;

        span {
          a {
            font-size: 14px;
            text-decoration: none;
            color: ${(props) => props.theme.black};
          }
        }
      }
    }

    .product-name-and-qmarks-container {
      justify-content: space-between;
      align-items: center;
      /* padding: 50px 0 0 0; */
      display: flex;

      .product-name {
        font-weight: 500;
        font-size: 42px;
        line-height: 38px;
        margin: 0 0 9px;
      }

      .qmarks {
        display: flex;
        gap: 8px;
        align-items: center;

        img {
          width: 70px;
          height: auto;
          aspect-ratio: ${QUALITY_MARK_ASPECT_RATIO};
          object-fit: contain;
        }
      }

      .right-content {
        display: flex;
        align-items: center;
        gap: 12px;
      }
    }
  }

  &.listing-detail-header {
    .product-name-bread-wrapper {
      padding-bottom: 0;
    }

    .product-name-and-qmarks-container {
      padding: 0;
    }

    .product-name {
      font-size: 32px;
      font-weight: 600;
      line-height: normal;
      margin: 0;
    }

    .right-content {
      padding-top: 22px;
      .identifier {
        font-size: 16px;
        color: ${({ theme }) => theme.colorText};
      }
    }

    .breadcrumbs-container {
      margin-bottom: 15px;
    }
  }
`;
